import Repository from './Repository';
import ListRequest from '@/models/ListRequest';
import NewPartner from '@/models/Partner/NewPartner';
import UpdatePartner from '@/models/Partner/UpdatePartner';
import DeletePartners from '@/models/Partner/DeletePartners';

const resource = '/partners';

export default {
    fetchPartners(listRequest: ListRequest) {
        return Repository.post(`${resource}/listpartners`, listRequest, {withCredentials: true});
    },
    newPartner(newPartner: NewPartner) {
        return Repository.post(`${resource}/createPartner`, newPartner, {withCredentials: true});
    },
    updatePartner(updatePartner: UpdatePartner) {
        return Repository.post(`${resource}/updatePartner`, updatePartner, {withCredentials: true});
    },
    deletePartner(deletePartners: DeletePartners) {
        return Repository.post(`${resource}/deletePartners`, deletePartners, {withCredentials: true});
    },
};
